/*eslint-disable*/
import React, { useContext, useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import isEmail from "validator/lib/isEmail"
import isURL from "validator/lib/isURL"
import isMobilePhone from "validator/es/lib/isMobilePhone"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"
import { ContentState, convertFromHTML, convertToRaw, EditorState } from "draft-js"
import { GridLoader } from "react-spinners"

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import InputAdornment from "@material-ui/core/InputAdornment"
import Radio from "@material-ui/core/Radio"
import Checkbox from "@material-ui/core/Checkbox"
import { Box, TextareaAutosize, TextField } from "@material-ui/core"

// @material-ui/icons
import {
  MailOutline,
  Check,
  Clear,
  Contacts,
  FiberManualRecord,
  AlternateEmail,
  Apartment,
  BusinessCenter,
  InsertPhoto,
  LocationCity,
  MyLocation,
  People,
  Phone,
  Web,
  Email,
  Language,
  ArrowBack,
  Save,
  Business,
  Info,
  LocationOn,
  Schedule,
  Category,
  PhotoLibrary,
} from "@material-ui/icons"

// Core components
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import CustomInput from "components/CustomInput/CustomInput.js"
import Button from "components/CustomButtons/Button.js"

// Private Components
import JAlert from "../../components/smallComponent/jAlert"
import CustomGooglePlace from "../../components/CustomGooglePlace/CustomGooglePlace"
import CropperX from "../../components/CropperX"
import CustomPhoneInput from "../../components/CustomPhoneInput/CustomPhoneInput"
import WorkingHours from "../../utils/hours/workingHours"
import GalleryUploader from "../../components/Medias/GalleryUploader"

// Context & API
import authContext from "../../context/AuthContext"
import {
  companyDetails,
  companyList,
  createCompany,
  getBusinessType,
  getMultiproAccountData,
  updateUserCompany,
  uploadImageCompany,
} from "../../api/companyAction"
import { getGroups } from "../../api/groupAction"
import { uploadMediaToFireStorage } from "../../services/FirebaseStorageService"
import {
  saveImageMetadataBatch,
  deleteImage,
  getImageByCompany,
} from "../../api/ImageActions"
import config from "../../config"
import { base64ToFileWithBlobUrl, revokeBlobUrl } from "../../utils/ImageUtils"

const BASE_URL = config.BASE_URL
const placeHolder = require("assets/img/placeholder.jpg")

const localStyles = {
  mainContainer: {
    background: "linear-gradient(135deg, #667eea 0%, #0d142b 100%)",
    minHeight: "100vh",
    padding: "40px 20px",
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  headerCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
  },
  pageTitle: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#2d3748",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  pageSubtitle: {
    fontSize: "16px",
    color: "#718096",
    fontWeight: "400",
    marginBottom: 0,
  },
  formCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    marginBottom: "24px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "32px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e2e8f0",
  },
  sectionBadge: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "700",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
  },
  sectionTitle: {
    flex: 1,
  },
  sectionTitleText: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#2d3748",
    margin: 0,
    marginBottom: "4px",
  },
  sectionSubtitle: {
    fontSize: "14px",
    color: "#718096",
    margin: 0,
  },
  inputGroup: {
    marginBottom: "24px",
  },
  inputLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "8px",
    display: "block",
  },
  inputHint: {
    fontSize: "12px",
    color: "#718096",
    marginTop: "4px",
    fontStyle: "italic",
  },
  imagePreviewContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    padding: "24px",
    background: "#f7fafc",
    borderRadius: "12px",
    border: "2px dashed #cbd5e0",
  },
  imagePreview: {
    maxWidth: "100%",
    height: "300px",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    objectFit: "cover",
  },
  uploadButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "12px 24px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
    },
  },
  actionBar: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    padding: "24px",
    background: "white",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    position: "sticky",
    bottom: "20px",
    zIndex: 100,
  },
  saveButton: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    padding: "14px 32px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 15px rgba(16, 185, 129, 0.4)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(16, 185, 129, 0.5)",
    },
  },
  backButton: {
    background: "#64748b",
    color: "white",
    padding: "14px 32px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "transform 0.2s, background 0.2s",
    "&:hover": {
      background: "#475569",
      transform: "translateY(-2px)",
    },
  },
  infoBox: {
    background: "#eff6ff",
    border: "2px solid #bfdbfe",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  infoIcon: {
    color: "#3b82f6",
    marginTop: "2px",
  },
  infoText: {
    fontSize: "14px",
    color: "#1e40af",
    lineHeight: "1.6",
    margin: 0,
  },
  requiredStar: {
    color: "#ef4444",
    marginLeft: "4px",
  },
  editorContainer: {
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    minHeight: "200px",
    padding: "12px",
  },
  centerIt: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}

const useStyles = makeStyles(localStyles)

const label = {
  pageTitle: "Gestion de l'établissement",
  pageTitleNew: "Nouvel établissement",
  pageSubtitle: "Remplissez les informations de votre établissement",
  section1Title: "Informations générales",
  section1Subtitle: "Les informations essentielles de votre établissement",
  section2Title: "Contact et localisation",
  section2Subtitle: "Coordonnées et adresse de l'établissement",
  section3Title: "Détails complémentaires",
  section3Subtitle: "Horaires, catégories et galerie d'images",
  company: "Nom de l'établissement",
  companyHint: "Le nom commercial de votre établissement",
  name: "Nom du contact",
  nameHint: "Information privée, non visible publiquement",
  email: "Email du contact",
  emailHint: "Information privée, utilisée pour les notifications",
  phone: "Téléphone",
  phoneHint: "Numéro principal de l'établissement",
  website: "Site internet",
  websiteHint: "URL complète de votre site web",
  address: "Adresse complète",
  addressHint: "L'adresse sera utilisée pour la géolocalisation",
  description: "Description",
  descriptionHint: "Décrivez votre établissement en quelques mots",
  businessType: "Catégorie principale",
  businessTypeHint: "Sélectionnez la catégorie qui correspond le mieux",
  openingHours: "Horaires d'ouverture",
  openingHoursHint: "Définissez vos horaires d'ouverture pour chaque jour",
  visuel: "Photo principale",
  visuelHint: "Photo de la devanture ou du logo (format recommandé: 3:2)",
  gallery: "Galerie d'images",
  galleryHint: "Ajoutez jusqu'à 10 photos ou vidéos de votre établissement",
  save: "Enregistrer",
  saveAndExit: "Enregistrer et quitter",
  back: "Retour",
  uploadImage: "Choisir une image",
  changeImage: "Modifier l'image",
  infoMessage:
    "Les champs marqués d'une étoile (*) sont obligatoires. Assurez-vous de remplir toutes les informations essentielles.",
  suspended: "Établissement suspendu",
}

export function CompanyManager(props) {
  const classes = useStyles()
  const { mpId } = useContext(authContext)
  const history = useHistory()

  // States
  const [loading, setLoading] = useState(true)
  const [groups, setGroups] = useState([])
  const [businessType, setBusinessType] = useState(undefined)
  const [showCropper, setShowCropper] = useState(false)
  const [base64Image, setBase64Image] = useState(undefined)
  const [isNewImage, setIsNewImage] = useState(false)
  const [currentImage, setCurrentImage] = useState(placeHolder.default)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const [coord, setCoord] = useState({ latitude: undefined, longitude: undefined })
  const [galleryImages, setGalleryImages] = useState([])
  const [pendingGalleryFiles, setPendingGalleryFiles] = useState([])
  const [coverImage, setCoverImage] = useState(null)
  const [coverBlobUrl, setCoverBlobUrl] = useState(null)
  const [newCoverFile, setNewCoverFile] = useState(null)
  const [imagesToDelete, setImagesToDelete] = useState([])
  const [uploading, setUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploadMessage, setUploadMessage] = useState("")
  const [info, setInfo] = useState({
    firstName: "green",
    lastName: "#495057",
    email: "green",
    password: "green",
    confirm_password: "green",
    companyName: "#495057",
    website: "#495057",
    phone: "green",
    address: "green",
    latitude: "#495057",
    longitude: "#495057",
    detail: "green",
    username: "green",
    cp: "green",
    city: "green",
    country: "green",
    validConditions: "green",
    cover: "green",
    businessType: "green",
    workingHours: "green",
  })
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    website: "",
    phone: "",
    detail: "",
    businessTypeId: "",
    address: "",
    workingHours: "",
    isSuspended: false,
  })

  const [defaultData, setDefaultData] = useState({
    defaultSubCompanyWorkingHours: null,
  })

  const cid = props.location?.state?.cid

  // useEffect pour charger les données
  useEffect(() => {
    if (mpId) {
      loadInitialData()
    }
  }, [mpId])

  const loadInitialData = async () => {
    try {
      // Charger les groupes
      // const groupsResponse = await getGroups()
      // if (groupsResponse?.data) {
      //   setGroups(groupsResponse.data)
      // }

      // Charger les types d'établissement
      const businessTypeResponse = await getBusinessType()
      if (businessTypeResponse?.data) {
        let st = businessTypeResponse.data.map(({ id, name, icon, ...rest }) => ({
          key: id,
          label: name,
          icon: icon,
        }))
        setBusinessType(st)
      }

      // Charger les données par défaut du multipro
      const defaultDataResponse = await getMultiproAccountData(mpId)
      if (defaultDataResponse?.data) {
        let x = defaultDataResponse.data.data
        setDefaultData({
          ...data,
          name: x.name,
          email: x.email,
          defaultSubCompanyPassword: x?.defaultSubCompanyPassword,
          emailSubCompanyEvent: x?.emailSubCompanyEvent ?? true,
          phone: x.phone || "",
          detail: x.detail,
          cover: x.iscover,
          businessLimit: 0,
          defaultSubCompanyWorkingHours: x.defaultSubCompanyWorkingHours
            ? x?.defaultSubCompanyWorkingHours
            : [],
        })
      }

      // Si on modifie un établissement existant
      if (cid) {
        const companyResponse = await companyDetails(cid)
        if (companyResponse?.data) {
          const company = companyResponse.data
          setData({
            firstName: company.firstname || "",
            lastName: company.lastname || "",
            email: company.email || "",
            companyName: company.name || "",
            website: company.website || "",
            phone: company.phone || "",
            detail: company.detail || "",
            businessType: company.businessType.id || 0,
            workingHours: company.workingHours || undefined,
            address: company.address || "",
            latitude: company.latitude,
            longitude: company.longitude,
            isSuspended: company.is_active === 0,
            cover: company.iscover,
          })

          setCoord({
            latitude: company.latitude,
            longitude: company.longitude,
          })

          if (company.detail) {
            const blocksFromHTML = convertFromHTML(company.detail)
            const contentState = ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            )
            setEditorState(EditorState.createWithContent(contentState))
          }

          // Charger l'image
          const imageUrl =
            company.is_firebase === 1
              ? company.cover_url
              : `${BASE_URL}img/company/cover-${cid}.jpg?${Date.now()}`
          setCurrentImage(imageUrl)

          // Charger la galerie
          const response = await getImageByCompany(cid)
          if (response?.success && response?.images) {
            console.log("galleryResponse", response)
            const cover = response.images.find((img) => img.isCover)
            const gallery = response.images
              .filter((img) => !img.isCover)
              .map((img) => ({
                ...img,
                type: "image",
                isNew: false,
                uploading: false,
              }))
            if (cover) setCoverImage(cover)
            setGalleryImages(gallery)
          }
        }
      }

      setLoading(false)
    } catch (error) {
      console.error("Erreur lors du chargement des données:", error)
      setLoading(false)
    }
  }

  /**
   * Note : management of businessType Change
   * @param e
   */
  const handleChangeBusinessType = (e) => {
    e.preventDefault()
    setData({ ...data, businessType: parseInt(e.target.value) })
  }

  /**
   * Note : feedback return from Google autocomple
   * @param _lat
   * @param _lng
   * @param _add
   * @param _city
   * @param _cp
   * @param _country
   */
  const handleCoordChange = (
    _lat,
    _lng,
    _add,
    _city = undefined,
    _cp = undefined,
    _country = undefined
  ) => {
    setCoord({
      ...coord,
      latitude: _lat,
      longitude: _lng,
    })
    setData((prevState) => ({
      ...prevState,
      latitude: _lat,
      longitude: _lng,
      address: _add,
      city: _city,
      cp: _cp,
      country: _country,
    }))
  }

  /**
   * Note: management of simple input
   * @param _text
   * @param _fromWich
   */
  const handleInputChange = (_text, _fromWich) => {
    if (_text) {
      setData({ ...data, [_fromWich]: _text })
      switch (_fromWich) {
        case "companyName":
          setInfo({ ...info, [_fromWich]: _text ? "#495057" : "coral" })
          break
        case "lastName":
          setInfo({ ...info, [_fromWich]: _text ? "#495057" : "coral" })
          break
        case "email":
          if (isEmail(_text)) {
            setInfo({ ...info, [_fromWich]: "green" })
          } else {
            setInfo({ ...info, [_fromWich]: "coral" })
          }
          break
        case "phone":
          if (isMobilePhone(_text)) {
            setInfo({ ...info, [_fromWich]: "green" })
          } else {
            setInfo({ ...info, [_fromWich]: "coral" })
          }
          break
        case "website":
          if (isURL(_text)) {
            setInfo({ ...info, [_fromWich]: "green" })
          } else {
            setInfo({ ...info, [_fromWich]: "coral" })
          }
          break
        case "longitude":
          setInfo({
            ...info,
            [_fromWich]: _text >= -180 && _text <= 180 ? "#495057" : "coral",
          })
          break
        case "latitude":
          setInfo({
            ...info,
            [_fromWich]: _text >= -90 && _text <= 90 ? "#495057" : "coral",
          })
          break
      }
    } else {
      setData({ ...data, [_fromWich]: _text })
    }
  }

  /**
   * Handle Cropped Image
   */
  const handleCroppedImage = async (base64) => {
    if (!base64) return

    try {
      const result = await base64ToFileWithBlobUrl(base64, "cover.jpg")

      if (coverBlobUrl) {
        revokeBlobUrl(coverBlobUrl)
      }

      setCoverBlobUrl(result.blobUrl)
      setNewCoverFile(result.file)
      setShowCropper(false)
    } catch (error) {
      console.error("Erreur conversion image:", error)
    }
  }

  /**
   * ###############################################################################
   * Saving the data                      handleRegister
   * ###############################################################################
   * */
  const handleRegister = async () => {
    // Validation
    if (!data.companyName) {
      alert("Le nom de l'établissement est obligatoire")
      return
    }
    if (!data.email || !isEmail(data.email)) {
      alert("Email invalide")
      return
    }
    if (data.website && !isURL(data.website)) {
      alert("URL du site web invalide")
      return
    }

    setLoading(true)

    try {
      const formData = {
        ...data,
        latitude: coord.latitude,
        longitude: coord.longitude,
        detail: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      }

      let response
      let companyId = cid

      if (cid) {
        response = await updateUserCompany(formData, cid)
      } else {
        response = await createCompany(formData, mpId)
        if (response?.status === 201) {
          companyId = response.data.cid
        } else {
          alert(response?.data?.message || "Erreur lors de la création")
          setLoading(false)
          return
        }
      }

      // Suppression des images marquées à supprimer
      if (imagesToDelete.length > 0) {
        setUploadMessage("Suppression des images...")
        for (const img of imagesToDelete) {
          try {
            await deleteImage("company", companyId, img.id)
          } catch (error) {
            console.error("Erreur suppression:", error)
          }
        }
        setImagesToDelete([])
      }

      // Combiner cover + galerie pour l'upload
      const allFilesToUpload = []
      const filesMetadata = []

      // Upload de l'image de couverture si nouvelle
      if (isNewImage && base64Image) {
        await uploadImageCompany(companyId, base64Image)
      }
      // ✅ Ajouter la nouvelle cover si elle existe
      if (newCoverFile) {
        allFilesToUpload.push({
          file: newCoverFile,
          isCover: true,
          position: 0,
        })
      }
      // ✅ Ajouter les fichiers de la galerie
      pendingGalleryFiles.forEach((f, index) => {
        allFilesToUpload.push({
          file: f.file,
          isCover: false,
          position: galleryImages.length + index + 1,
        })
      })

      // Upload des nouvelles images de la galerie
      if (allFilesToUpload.length > 0) {
        setUploadMessage("Upload des médias...")
        setUploading(true)

        // Extraire les fichiers bruts
        const files = allFilesToUpload.map((f) => f.file)
        console.log("files to upload", files)
        // Upload vers Firebase
        const uploadedFiles = await uploadMediaToFireStorage(
          "company",
          companyId,
          files,
          setUploadProgress,
          setUploadMessage
        )

        if (uploadedFiles.length > 0) {
          // ✅ Créer les métadonnées en préservant isCover
          const imagesMetadata = uploadedFiles.map((file, index) => ({
            path: file.path,
            url: file.downloadUrl,
            isCover: allFilesToUpload[index].isCover,
            position: allFilesToUpload[index].position,
          }))

          // Sauvegarder les métadonnées
          const metadataPayload = {
            entityType: "company",
            entityId: companyId,
            images: imagesMetadata,
          }

          const saved = await saveImageMetadataBatch(metadataPayload)

          // if (saved.success) {
          //   // Ajouter les nouvelles images à la galerie
          //   setGalleryImages((prev) => [
          //     ...prev,
          //     ...saved.images.map((img) => ({
          //       ...img,
          //       type: "image",
          //       isNew: false,
          //       uploading: false,
          //     })),
          //   ])
          //   setPendingGalleryFiles([])
          // }
        }

        setUploading(false)
      }

      alert("Établissement enregistré avec succès")
      history.push("/admin/company-list")
    } catch (error) {
      console.error("Erreur lors de l'enregistrement:", error)
      alert("Une erreur est survenue lors de l'enregistrement")
    } finally {
      setLoading(false)
    }
  }

  const handleBack = () => {
    history.push("/admin/company-list")
  }

  const getPlanning = (planningData) => {
    setData((prev) => ({
      ...prev,
      workingHours: planningData,
    }))
  }

  const handleFilesSelected = (filesWithMeta) => {
    // Ajouter les fichiers en attente avec prévisualisations
    const newPendingFiles = filesWithMeta.map((f) => ({
      ...f,
      id: `temp_${Date.now()}_${Math.random()}`,
      isNew: true,
      uploading: false,
    }))

    setPendingGalleryFiles((prev) => [...prev, ...newPendingFiles])
  }

  const handleRemoveImage = (image, index) => {
    // Si c'est une image déjà sauvegardée
    if (image.id && !image.isNew) {
      setImagesToDelete((prev) => [...prev, image])
      setGalleryImages((prev) => prev.filter((_, i) => i !== index))
    }
    // Si c'est un fichier en attente
    else {
      const allImages = [...galleryImages, ...pendingGalleryFiles]
      const targetImage = allImages[index]

      if (targetImage && targetImage.isNew) {
        setPendingGalleryFiles((prev) => prev.filter((f) => f.id !== targetImage.id))

        // Révoquer l'URL blob
        if (targetImage.preview && targetImage.preview.startsWith("blob:")) {
          URL.revokeObjectURL(targetImage.preview)
        }
      }
    }
  }

  if (loading) {
    return (
      <div className={classes.mainContainer}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <GridLoader color="#667eea" loading={loading} size={50} />
        </div>
      </div>
    )
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.contentWrapper}>
        {/* Header */}
        <div className={classes.headerCard}>
          <div className={classes.pageTitle}>
            <Business style={{ fontSize: "40px", color: "#667eea" }} />
            {cid ? label.pageTitle : label.pageTitleNew}
          </div>
          <p className={classes.pageSubtitle}>{label.pageSubtitle}</p>
        </div>

        {/* Info Box */}
        <div className={classes.infoBox}>
          <Info className={classes.infoIcon} />
          <p className={classes.infoText}>{label.infoMessage}</p>
        </div>

        {/* PARTIE 1: Informations générales */}
        <div className={classes.formCard}>
          <div className={classes.sectionHeader}>
            <div className={classes.sectionBadge}>1</div>
            <div className={classes.sectionTitle}>
              <h3 className={classes.sectionTitleText}>{label.section1Title}</h3>
              <p className={classes.sectionSubtitle}>{label.section1Subtitle}</p>
            </div>
          </div>

          <GridContainer spacing={3}>
            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>
                  {label.company}
                  <span className={classes.requiredStar}>*</span>
                </label>
                <CustomInput
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: data.companyName,
                    onChange: (e) =>
                      setData({ ...data, companyName: e.target.value }),
                    startAdornment: (
                      <InputAdornment position="start">
                        <BusinessCenter />
                      </InputAdornment>
                    ),
                  }}
                />
                <p className={classes.inputHint}>{label.companyHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.name}</label>
                <CustomInput
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: data.lastName,
                    onChange: (e) => setData({ ...data, lastName: e.target.value }),
                    startAdornment: (
                      <InputAdornment position="start">
                        <People />
                      </InputAdornment>
                    ),
                  }}
                />
                <p className={classes.inputHint}>{label.nameHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.description}</label>
                <div className={classes.editorContainer}>
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={(newState) => setEditorState(newState)}
                    placeholder="Décrivez votre établissement..."
                    toolbar={{
                      options: [
                        // "inline",
                        // "blockType",
                        // "fontSize",
                        // "fontFamily",
                        // "list",
                        // "textAlign",
                        // "link",
                        // "embedded",
                        "emoji",
                        // "history",
                      ],
                      inline: {
                        inDropdown: false,
                        className: undefined,
                        component: undefined,
                        dropdownClassName: undefined,
                        options: [
                          "bold",
                          // "italic",
                          // "underline",
                          // "strikethrough",
                          // "monospace",
                          // "superscript",
                          // "subscript",
                        ],
                      },
                    }}
                  />
                </div>
                <p className={classes.inputHint}>{label.descriptionHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.businessType}</label>
                <FormControl fullWidth>
                  <select
                    value={data.businessType}
                    onChange={handleChangeBusinessType}
                    style={{
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      color: "#2d3748",
                    }}
                  >
                    <option key={-1} value="">
                      Sélectionner une catégorie
                    </option>
                    {businessType?.map((type) => (
                      <option
                        key={type.key}
                        value={type.key}
                        style={{ color: "#2d3748" }}
                      >
                        {type.label}
                      </option>
                    ))}
                  </select>
                </FormControl>
                <p className={classes.inputHint}>{label.businessTypeHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={data.isSuspended}
                      onChange={(e) =>
                        setData({ ...data, isSuspended: e.target.checked })
                      }
                      color="primary"
                    />
                  }
                  label={label.suspended}
                />
              </div>
            </GridItem>

            <GridItem xs={12}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.visuel}</label>
                <div className={classes.imagePreviewContainer}>
                  <img
                    src={
                      coverBlobUrl ??
                      coverImage?.url ??
                      currentImage ??
                      placeHolder.default
                    }
                    alt="Événement"
                    className={classes.imagePreview}
                  />
                  {/*<img*/}
                  {/*  src={base64Image || currentImage}*/}
                  {/*  alt="Établissement"*/}
                  {/*  className={classes.imagePreview}*/}
                  {/*/>*/}
                  <button
                    className={classes.uploadButton}
                    onClick={() => setShowCropper(true)}
                  >
                    <InsertPhoto />
                    {base64Image ? label.changeImage : label.uploadImage}
                  </button>
                </div>
                <p className={classes.inputHint}>{label.visuelHint}</p>
              </div>
            </GridItem>
          </GridContainer>
        </div>

        {/* PARTIE 2: Contact et localisation */}
        <div className={classes.formCard}>
          <div className={classes.sectionHeader}>
            <div className={classes.sectionBadge}>2</div>
            <div className={classes.sectionTitle}>
              <h3 className={classes.sectionTitleText}>{label.section2Title}</h3>
              <p className={classes.sectionSubtitle}>{label.section2Subtitle}</p>
            </div>
          </div>

          <GridContainer spacing={2}>
            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>
                  {label.email}
                  <span className={classes.requiredStar}>*</span>
                </label>
                <CustomInput
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "email",
                    value: data.email,
                    onChange: (e) => setData({ ...data, email: e.target.value }),
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    ),
                  }}
                />
                <p className={classes.inputHint}>{label.emailHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.phone}</label>
                <CustomPhoneInput
                  labelText={label.phone}
                  id="phone"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  value={data?.phone}
                  phoneChange={(e) => {
                    handleInputChange(e, "phone")
                  }}
                />
                <p className={classes.inputHint}>{label.phoneHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.website}</label>
                <CustomInput
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "url",
                    value: data.website,
                    onChange: (e) => setData({ ...data, website: e.target.value }),
                    startAdornment: (
                      <InputAdornment position="start">
                        <Language />
                      </InputAdornment>
                    ),
                  }}
                />
                <p className={classes.inputHint}>{label.websiteHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.address}</label>
                <CustomGooglePlace
                  formControlProps={{
                    fullWidth: true,
                  }}
                  labelText={label.address}
                  value={data?.address}
                  coord={(lat, lng, add, city, cp, country) => {
                    handleCoordChange(lat, lng, add, city, cp, country)
                  }}
                />
                <p className={classes.inputHint}>{label.addressHint}</p>
              </div>
            </GridItem>
          </GridContainer>
        </div>

        {/* PARTIE 3: Détails complémentaires */}
        <div className={classes.formCard}>
          <div className={classes.sectionHeader}>
            <div className={classes.sectionBadge}>3</div>
            <div className={classes.sectionTitle}>
              <h3 className={classes.sectionTitleText}>{label.section3Title}</h3>
              <p className={classes.sectionSubtitle}>{label.section3Subtitle}</p>
            </div>
          </div>

          <GridContainer spacing={3}>
            <GridItem xs={12}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.openingHours}</label>
                {defaultData.defaultSubCompanyWorkingHours && (
                  <WorkingHours
                    fieldName="location[working_hours]"
                    dataStr={data.workingHours}
                    backFire={(planningData) => getPlanning(planningData)}
                  />
                )}
                <p className={classes.inputHint}>{label.openingHoursHint}</p>
              </div>
            </GridItem>

            <GridItem xs={12}>
              <div className={classes.inputGroup}>
                <label className={classes.inputLabel}>{label.gallery}</label>
                <GalleryUploader
                  images={[...galleryImages, ...pendingGalleryFiles]}
                  onFilesSelected={handleFilesSelected}
                  onRemoveImage={handleRemoveImage}
                  maxMedias={10}
                  disabled={uploading}
                  progress={uploadProgress}
                  progressMessage={uploadMessage}
                />
                <p className={classes.inputHint}>{label.galleryHint}</p>
              </div>
            </GridItem>
          </GridContainer>
        </div>

        {/* Action Bar */}
        <div className={classes.actionBar}>
          <button className={classes.backButton} onClick={handleBack}>
            <ArrowBack />
            {label.back}
          </button>
          <button className={classes.saveButton} onClick={handleRegister}>
            <Save />
            {cid ? label.save : label.save}
          </button>
        </div>

        {/* Cropper Modal */}
        <CropperX
          visibility={showCropper}
          backInfo={() => setShowCropper(false)}
          title={label.visuel}
          image={currentImage}
          b64={handleCroppedImage}
          // b64={(base64) => {
          //   setIsNewImage(true)
          //   setBase64Image(base64)
          // }}
          direction="row"
          cropAreaAspect={3 / 2}
        />
      </div>
    </div>
  )
}
